import { useQuery } from '@apollo/client';
import type * as React from 'react';

import {
  GenericError,
  useCareerHubMainPageView,
} from '@xing-com/crate-career-hub-common';
import type { CareerHubTopicsQuery } from '@xing-com/crate-career-hub-topics';
import { CareerHubTopicsDocument } from '@xing-com/crate-career-hub-topics';

import { Topic } from './topic';
import { Styled } from './topic-list.styles';
import { TopicSkeleton } from './topic-skeleton';

export const TopicList: React.FC = () => {
  const { data, loading, error, refetch, networkStatus } =
    useQuery<CareerHubTopicsQuery>(CareerHubTopicsDocument, {
      notifyOnNetworkStatusChange: true,
    });

  useCareerHubMainPageView(
    data?.careerHubTopics?.collection?.map((topic) => topic?.trackingKey || '')
  );

  if (error) return <GenericError {...{ refetch }} />;

  const topicList = data?.careerHubTopics?.collection?.map((topic) =>
    topic ? (
      <Topic
        key={topic.title}
        {...{
          slug: topic.key,
          title: topic.title,
          description: topic.description ?? '',
          articles: topic.articles,
        }}
      />
    ) : null
  );

  const isRefetching = networkStatus === 4;

  return (
    <Styled.Wrapper>
      {loading || isRefetching ? <TopicSkeleton /> : topicList}
    </Styled.Wrapper>
  );
};
